<template>
  <v-row class="match-height">
    <v-col cols="12">
      <v-card>
        <v-card-title>{{ $t("Uutiset") }}</v-card-title>
        <v-card-text>
          <v-form v-on:submit.prevent="submit" ref="form">
            <div class="mb-3">
              <v-radio-group v-model="resource.group" :label="$t('Julkaise ryhmään')" :rules="[requiredRadio]" required>
                <v-radio v-for="group in user.admin_groups" :key="group.id" :value="group.id" :label="group.name" />
              </v-radio-group>
            </div>

            <div class="mb-3">
              <v-select v-model="resource.folder" :items="folderItems" item-text="text" item-value="value"
                :label="$t('Kansio')" outlined clearable :loading="foldersLoading">
                <template v-slot:item="{ item }">
                  <div class="d-flex align-center" :style="{ marginLeft: `${item.depth * 12}px` }">
                    <v-icon v-if="item.depth > 0" small class="mr-2">{{ icons.mdiSubdirectoryArrowRight }}</v-icon>
                    <span>{{ item.text }}</span>
                  </div>
                </template>
              </v-select>
            </div>

            <v-card outlined elevation="0" class="mb-4">
              <v-tabs grow v-model="typeTab" @change="typeChanged">
                <v-tab>{{ $t("Tiedosto") }}</v-tab>
                <v-tab>{{ $t("Linkki") }}</v-tab>
              </v-tabs>
              <v-tabs-items v-model="typeTab">
                <v-tab-item>
                  <div style="padding: 20px">
                    <v-file-input ref="file" outlined class="mb-4" hide-details="auto"
                      :label="$t('Valitse uusi tiedosto')" @change="handleFileUpload"
                      accept=".jpeg,.jpg,.png, .pdf, .doc, .docx, .ppt, .pptx, .xlsx, .xls"
                      :rules="[validateFile]"></v-file-input>
                    <div v-if="resource.fileUrl && resource.filename">
                      <v-chip class="ma-2" :link="true" target="_blank">{{ resource.filename
                        }}</v-chip>
                    </div>
                  </div>
                </v-tab-item>
                <v-tab-item>
                  <div style="padding: 20px">
                    <v-text-field :label="$t('Linkki')" v-model="resource.link" outlined class="mb-4"
                      hide-details="auto" :rules="[
                        (v) => {
                          return (
                            resource.resource_type ==
                            resource_types.document.value ||
                            !!v ||
                            $t('Tämä tieto on pakollinen')
                          );
                        },
                      ]"></v-text-field>
                  </div>
                </v-tab-item>
              </v-tabs-items>

              <!-- <v-input
                class="ml-4 mb-4"
                hidden
                hide-details="auto"
                :rules="[validateFileOrLink]"
              ></v-input> -->
            </v-card>

            <v-card outlined elevation="0" class="mb-4">
              <v-tabs v-model="tab" grow>
                <v-tab v-for="lang in tenant.languages" :key="'langtab-' + lang.code">
                  <img :src="lang.icon" style="max-height: 20px" />
                  &nbsp;&nbsp;{{ lang.name }}
                  &nbsp;
                  <v-icon v-if="langOk(lang.code)" color="success">
                    {{ icons.mdiCheck }}
                  </v-icon>
                  <v-icon v-else color="error">
                    {{ icons.mdiBlockHelper }}
                  </v-icon>
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item v-for="lang in tenant.languages" :key="'langtabitem-' + lang.code">
                  <div style="padding: 20px 20px 0 20px">
                    <img :src="lang.icon" style="max-height: 14px" />
                    <br />
                    <br />

                    <v-text-field :id="'news-title-' + lang.code" v-model="resource.translations[lang.code].title"
                      :label="$t('Otsikko')" outlined class="mb-4" hide-details="auto" />
                    <div style="height: 240px">
                      <v-textarea counter outlined :rules="[
                        (v) => v.length <= 500 || $t('Max 500 merkkiä'),
                      ]" :label="$t('Kuvaus')" :id="'news-text-' + lang.code"
                        v-model="resource.translations[lang.code].description" height="200" />
                    </div>
                  </div>
                </v-tab-item>
              </v-tabs-items>

              <v-input class="ml-4 mb-4" hidden hide-details="auto" :rules="[validateLangs]"></v-input>
            </v-card>

            <v-card outlined class="mt-4" v-if="tenant.settings.acknowledgments_enabled">
              <v-card-title>{{ $t("Lukukuittaus") }}</v-card-title>
              <v-card-text>
                <v-switch dense hide-details="auto" v-model="resource.require_acknowledgment"
                  :label="$t('Vaadi lukukuittaus')" class="mb-2 mt-0"></v-switch>

                <div v-if="resource.require_acknowledgment" class="mt-4">
                  <v-sheet outlined>
                    <v-tabs v-model="acknowledgmentTab" grow>
                      <v-tab v-for="lang in tenant.languages" :key="'ack-tab-' + lang.code">
                        <img :src="lang.icon" style="max-height: 20px" />
                        &nbsp;&nbsp;{{ lang.name }}
                      </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="acknowledgmentTab">
                      <v-tab-item v-for="lang in tenant.languages" :key="'ack-tabitem-' + lang.code">
                        <div style="padding: 20px">
                          <br />
                          <v-text-field outlined :label="$t('Selite (valinnainen)')"
                            v-model="resource.translations[lang.code].acknowledgment_description"
                            :disabled="!langOk(lang.code)"
                            :hint="$t('Teksti näytetään käyttäjille lukukuittauksen yhteydessä')" persistent-hint>
                          </v-text-field>
                        </div>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-sheet>
                  <br>

                  <v-text-field v-if="resource.require_acknowledgment" :label="$t('Versio')"
                    :hint="$t('Jos nostatte versionumeroa, käyttäjiltä vaaditaan sisällölle uudelleen lukukuittaus')"
                    :persistent-hint="true" v-model="resource.acknowledgment_version" type="number" min="1" outlined
                    class="mt-2 mb-2"></v-text-field>
                </div>
              </v-card-text>
            </v-card>

            <v-switch v-model="resource.published" :label="$t('Julkaise')" class="mb-5" persistent-hint :hint="resource.published
              ? $t('Tiedosto julkaistaan heti')
              : $t('Tiedosto tallennetaan luonnoksena')
              "></v-switch>

            <v-alert color="error" text v-if="!formIsValid">
              {{ $t("Tarkista lomakkeen tiedot") }}
            </v-alert>

            <v-btn v-if="resource.id" color="error" class="mr-3" type="button" @click="removeResource">
              {{ $t("Poista") }}
            </v-btn>
            <v-btn color="primary" type="submit" :loading="isSubmitting">
              {{ $t("Tallenna") }}
            </v-btn>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { onMounted, reactive, ref, computed } from "@vue/composition-api";
import { useTranslations } from "@/@core/libs/i18n";
import useAuth from "@/useAuth";
import { required, requiredRadio } from "@/@core/utils/validation";
import { mdiCheck, mdiBlockHelper, mdiSubdirectoryArrowRight } from "@mdi/js";
import adminApi from "@/api/admin";
import resource_types from "@core/utils/resource_types";
import { useRouter } from "@/@core/utils";
import { i18n } from "@/plugins/i18n";
import { MAX_FILE_SIZE } from "@core/utils/constants";

export default {
  props: ["id"],
  setup(props) {
    const { router } = useRouter();
    const { tenant, user } = useAuth();

    const tab = ref(null);
    const typeTab = ref(null);
    const form = ref(null);
    const formIsValid = ref(true);
    const isSubmitting = ref(false);
    const acknowledgmentTab = ref(null);
    const formErrors = ref([]);

    // Folders state
    const folders = ref([]);
    const foldersLoading = ref(false);

    // Transform folders for dropdown selection with hierarchy
    const folderItems = computed(() => {
      // Recursive function to build hierarchical tree with depth
      const buildTree = (parentId = null, depth = 0) => {
        const children = folders.value.filter(f => f.parent === parentId);

        return children.flatMap((folder) => {
          return [
            {
              text: folder.title,
              value: folder.id,
              depth: depth
            },
            ...buildTree(folder.id, depth + 1)
          ];
        });
      };

      return buildTree();
    });

    const resource = reactive({
      group: null,
      id: null,
      translations: {},
      published: false,
      resource_type: 1,
      file: null,
      fileUrl: "",
      filename: "",
      link: null,
      folder: null,
      require_acknowledgment: false,
      acknowledgment_version: 1
    });

    tenant.value.languages.forEach((lang) => {
      resource.translations[lang.code] = {
        title: "",
        description: "",
        acknowledgment_description: "",
      };
    });

    const fetchFolders = async () => {
      foldersLoading.value = true;
      const response = await adminApi.getResourceFolders(1);
      if (response.ok) {
        folders.value = response.data.results || [];

        // Preselect folder from query parameter if creating new resource
        if (!props.id && router.currentRoute.query.folder) {
          const folderId = parseInt(router.currentRoute.query.folder);
          if (!isNaN(folderId)) {
            resource.folder = folderId;
          }
        }
      }
      foldersLoading.value = false;
    };

    const fetchResource = async (id) => {
      const response = await adminApi.getResource(id);
      if (response.ok) {
        resource.group = response.data.group;
        resource.id = response.data.id;
        resource.published = response.data.published;
        resource.resource_type = response.data.resource_type;
        resource.fileUrl = response.data.file;
        resource.filename = response.data.filename;
        resource.link = response.data.link;
        resource.folder = response.data.folder;
        resource.require_acknowledgment = response.data.require_acknowledgment;
        resource.acknowledgment_version = response.data.acknowledgment_version;
        Object.keys(response.data.translations).forEach((lang) => {
          resource.translations[lang] = response.data.translations[lang];
        });
        typeTab.value = resource.resource_type - 1;
      } else {
        alert(response.error);
      }
    };

    const submit = async () => {
      formIsValid.value = true;
      if (form.value.validate()) {
        isSubmitting.value = true;
        const response = await adminApi.saveResource(resource);
        if (response.ok) {
          router.push({ name: "admin-resource-list" });
        } else {
          alert(response.error);
        }
        isSubmitting.value = false;
      } else {
        formIsValid.value = false;
      }
    };

    const removeResource = async () => {
      if (confirm(i18n.t("Haluatko varmasti poistaaa tiedoston?"))) {
        const response = await adminApi.deleteResource(resource.id);
        if (response.ok) {
          router.replace({ name: "admin-resource-list" });
        } else {
          alert(response.error);
        }
      }
    };

    const typeChanged = (i) => {
      resource.resource_type =
        i == 0 ? resource_types.document.value : resource_types.link.value;
    };

    const handleFileUpload = (file) => {
      resource.file = file;
      resource.filename = file ? file.name : null;
    };

    const langOk = (langCode) => {
      const ok =
        resource.translations[langCode].title &&
        resource.translations[langCode].description;

      return ok;
    };

    const validateLangs = () => {
      let valid = false;
      tenant.value.languages.forEach((lang) => {
        if (
          resource.translations[lang.code].title &&
          resource.translations[lang.code].description
        )
          valid = true;
      });

      if (valid) {
        return true;
      } else {
        return i18n.t("Otsikko tai kuvaus puuttuu");
      }
    };

    const validateFileOrLink = () => {
      if (
        resource.resource_type == resource_types.document.value &&
        !resource.filename &&
        !resource.file
      ) {
        return i18n.t("Tiedosto puuttuu");
      } else if (
        resource.resource_type == resource_types.link.value &&
        !resource.link
      ) {
        return i18n.t("Linkki puuttuu");
      }

      return true;
    };


    const validateFile = (v) => {
      if (resource.resource_type == resource_types.link.value) return true;

      if (!resource.file && !resource.fileUrl)
        return i18n.t("Tämä tieto on pakollinen");

      return !v || v.size < MAX_FILE_SIZE || i18n.t('Tiedoston maksimikoko on 10MB');
    };


    // UnRegister on leave
    onMounted(() => {
      fetchFolders();
      if (props.id) {
        fetchResource(props.id);
      }
    });

    return {
      resource,
      tenant,
      user,
      tab,
      typeTab,
      resource_types,
      formErrors,
      folders,
      foldersLoading,
      folderItems,
      typeChanged,
      langOk,
      isSubmitting,
      acknowledgmentTab,
      handleFileUpload,
      submit,
      removeResource,
      form,
      required,
      requiredRadio,
      validateLangs,
      validateFileOrLink,
      validateFile,
      formIsValid,
      icons: {
        mdiCheck,
        mdiBlockHelper,
        mdiSubdirectoryArrowRight,
      },
    };
  },
};
</script>
